import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { mediaUrl } from "../lib/api";
import { CheckCircle2, Award, BookOpen, Scale, Download } from "lucide-react";

const FALLBACK = "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=900&q=80";

export default function About() {
  const { settings } = useSettings();
  const photo = settings?.host_photo_url ? mediaUrl(settings.host_photo_url) : FALLBACK;
  const name = settings?.host_name || "Enzo Lavolta";
  const title = settings?.host_title || "Consulente del Lavoro";
  const bio = settings?.bio || "";
  const cv = settings?.cv_url ? mediaUrl(settings.cv_url) : "";
  const about = settings?.about || {};
  const areas = about.areas?.length ? about.areas : ["Contrattualistica del lavoro", "Contenzioso e licenziamenti", "Previdenza e contribuzione INPS", "Contrattazione collettiva (CCNL)", "Sicurezza sul lavoro", "Smart working e nuove forme"];
  const aboutStats = about.stats?.length ? about.stats : [{ value: "12+ anni", label: "Di esperienza" }, { value: "500+ casi", label: "Gestiti" }, { value: "50+ episodi", label: "Pubblicati" }];
  const STAT_ICONS = [Award, Scale, BookOpen];

  return (
    <div>
      <section className="bg-navy py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-serif text-4xl sm:text-5xl font-bold text-white">Chi sono</h1>
        </div>
      </section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-[380px_1fr] gap-12 items-start">
        <div>
          <img src={photo} alt={name} className="rounded-2xl shadow-xl w-full object-cover aspect-[4/5]" />
          {cv && (
            <a href={cv} target="_blank" rel="noopener noreferrer" download data-testid="download-cv" className="mt-4 flex items-center justify-center gap-2 bg-white border border-slate-200 text-navy rounded-full py-3 font-medium hover:border-navy transition-all">
              <Download className="w-4 h-4" /> Scarica il CV
            </a>
          )}
        </div>
        <div>
          <span className="text-sm uppercase tracking-[0.2em] font-semibold text-gold">{title}</span>
          <h2 className="font-serif text-4xl font-bold text-navy mt-2 mb-6">{name}</h2>
          {bio.split("\n\n").map((p, i) => (
            <p key={i} className="text-lg text-slate-600 leading-relaxed mb-4">{p}</p>
          ))}
          <div className="grid sm:grid-cols-3 gap-4 my-8">
            {aboutStats.map((x, i) => {
              const Icon = STAT_ICONS[i % STAT_ICONS.length];
              return (
                <div key={i} className="bg-white border border-slate-100 rounded-xl p-5 text-center shadow-sm">
                  <Icon className="w-6 h-6 text-gold mx-auto mb-2" />
                  <div className="font-serif text-xl font-bold text-navy">{x.value}</div>
                  <div className="text-sm text-slate-400">{x.label}</div>
                </div>
              );
            })}
          </div>
          <h3 className="font-serif text-2xl font-semibold text-navy mb-4">Aree di competenza</h3>
          <ul className="grid sm:grid-cols-2 gap-3 mb-8">
            {areas.map((t) => (
              <li key={t} className="flex items-center gap-2.5 text-slate-700"><CheckCircle2 className="w-5 h-5 text-emerald shrink-0" /> {t}</li>
            ))}
          </ul>
          <Link to="/contatti" data-testid="about-contact-cta" className="inline-block bg-navy text-white rounded-full px-8 py-3 font-medium hover:bg-petrol transition-all">Richiedi una consulenza</Link>
        </div>
      </div>
    </div>
  );
}
